<template>
    <Dialog :open="open" :title="popupTitle" @close="close" @enter="accept">
        <v-card class="elevation-0 pa-0 ma-0">
            <v-card-title class="page-title font-weight-medium pa-0 pb-3">{{
                title
                }}
            </v-card-title>
            <v-card-text v-if="messages.length"
                         class="body-1 pa-0">{{ messages.join(' ') }}
            </v-card-text>
            <v-card-actions class="pt-4 px-0">
                <v-container>
                    <v-row>
                        <v-col class="pl-0" md="6">
                            <v-btn
                                    block
                                    class="text-h6  accentText--text"
                                    color="accent"
                                    large
                                    @click="accept">
                                {{ acceptTitle }}
                            </v-btn>
                        </v-col>
                        <v-col class="pr-0" md="6">
                            <v-btn
                                    block
                                    class="text-h6"
                                    color="secondary primary--text"
                                    large
                                    @click="close">
                                {{ $t('close') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";

export default {
  name: "ConfirmDialog",
  components: {Dialog},
  props: {
    popupTitle: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    acceptTitle: {
      type: String,
      required: true
    },
    messages: {
      type: Array,
      required: false,
      default: () => [],
    }
  },
  data() {
    return {
      open: false,
      resolve: null,
      reject: null
    };
  },
  methods: {
    openDialog() {
      this.open = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    close() {
      this.resolve(false);
      this.open = false;
    },
    accept() {
      this.open = false;
      this.resolve(true);
    }
  }
};
</script>

<style scoped>

</style>